import {useAuth} from "hooks/useAuth";
import React, {ReactNode} from "react";
import {Navigate} from "react-router-dom";
import UnauthorizedContainer from "components/UnauthorizedContainer";


interface ProtectedRouteProps {
    children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({children}) => {

    const [{isSignedIn}] = useAuth();

    return isSignedIn ? (
        <UnauthorizedContainer>
            {children}
        </UnauthorizedContainer>
    ) : (
        <Navigate to={"/"}/>
    );
};

export default ProtectedRoute;
